"use strict";
define('components/email_batch_delay_send',[], function() {
    return {
        init: function(detailsRow, emailId, email_send_date, timezone_str) {
            if (email_send_date) {
                var deleteButtonHtml = '<div style="display: flex; justify-content: flex-end; gap:5px; align-items: center;">' +
                    '<span class="email-schedule-text">' +
                    'Scheduled for ' + email_send_date + ' (' + timezone_str + ')' +
                    '</span>' +
                    '<button class="cancel-email-btn" data-id="' + emailId + '" href="/scheduled_email_batch/' + emailId + '/delete" data-toggle="modal" data-target="#small-modal">' +
                    '<div class="cancel-email-text"><i class="fas fa-trash" style="margin-right: 5px;"></i> Cancel send </div>' +
                    '</button>' +
                    '</div>';
                detailsRow.children(":last").prepend(deleteButtonHtml);
            }
        }
    };
});

